// Module
var code = "<script>let $ctrl</script> <form ng-submit=\"$ctrl.save()\" ng-attr-name=\"{{ $editForm.formName }}\" autocomplete=\"off\"> <input type=\"submit\" style=\"display:none\"> <ng-transclude></ng-transclude> </form> ";
// Exports
module.exports = code;